module.exports = __webpack_public_path__ + "img/get-service-illustrator.99c4eff6.svg";